import { ViewStatesSearchComponent } from './view-states-search.component';

export default angular
  .module('sfMobile.components.view-states-search', [
    'sfMobile.templates',
    'sfMobile.components.empty-search',
    'sfMobile.components.loader',
  ])
  .component('sfViewStatesSearch', ViewStatesSearchComponent).name;
